import styled from 'styled-components';

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding-block: ${({ theme }) => theme.spacing.x5};
  padding-inline-start: ${({ theme }) => theme.spacing.x3};
  padding-inline-end: ${({ theme }) => theme.spacing.x5};
  background: ${({ theme }) => theme.palette.white};
`;

export const Header = styled.div`
  display: flex;
  justify-content: 'space-between';
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const FormTitle = styled.span`
  font-size: ${({ theme }) => theme.fs.md};
  color: ${({ theme }) => theme.palette.primary};
`;

export const Form = styled.form``;
export const FormGroup = styled.div`
  display: flex;
  margin: ${({ theme }) => `-${theme.spacing.x2}`};
  flex-wrap: wrap;
`;
export const Field = styled.div`
  padding: ${({ theme }) => `${theme.spacing.x2}`};
  width: 50%;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    width: 100%;
  }
`;
